import { useRef, useEffect, useState } from 'react';
import { I18n } from 'aws-amplify';
import PropTypes from 'prop-types';

import '../MCPServerSetting.css';
import Utils from '@/common/utils/utils';
import Constant from '@/common/constant/Constant';
import OverFlowTooltipWithTabsMui from '@/component/common/OverFlowTooltipWithTabsMui';
import { renderSettingMCPServer } from '../handler/MCPServerUIHandler';
import { handleUpdateMCPServerByAction} from '../handler/MCPServerLogicHandler';
import ConfirmDialog from '@/common/dialog/ConfirmDialog';

import { useRecoilState, useSetRecoilState } from 'recoil';
import { closeTabId, multiPanelAtom } from '@/state/atom/panelAtom';
import { closePanelTabSelector } from '@/state/selector/panelSelector';

MCPServerListInProject.propTypes = {
    panelType: PropTypes.string,
    setEditApiData: PropTypes.func,
    setIsLoading: PropTypes.func,
    corporationDetail: PropTypes.object,
    projectInuseDetail: PropTypes.object,
    userDetail: PropTypes.object,
    setListSettingApiProject: PropTypes.array,
    listSettingApiProject: PropTypes.array,
    props: PropTypes.object,
};

function MCPServerListInProject({
    setIsLoading,
    panelType,
    setEditApiData,
    corporationDetail,
    projectInuseDetail,
    userDetail,
    listSettingApiProject,
    setListSettingApiProject,
    props
}) {
    const mcpServerListBody = useRef(null);

    const [closeTabIdState, setCloseTabIdState] = useRecoilState(closeTabId);
    const closePanelTab = useSetRecoilState(closePanelTabSelector);
    const [panelList, setPanelList] = useRecoilState(multiPanelAtom);

    const [isShowPopUpReload, setIsShowPopUpReload] = useState(false);

    const isActiveProject = apiData => {
        let projectActived = apiData?.projectActived || [];
        let isActiveProject = projectActived?.includes(projectInuseDetail?.id);
        return isActiveProject;
    };

    const callActiveInProject = (activeValue, mcpServerData) => {
        const projectId = projectInuseDetail?.id;

        const projectActived = activeValue
            ? [...(mcpServerData?.projectActived || []), projectId]
            : (mcpServerData?.projectActived || []).filter(id => id !== projectId);

        const mcpData = {
            id: mcpServerData.id,
            projectActived
        };
        handleUpdateSuccess(null, mcpServerData, projectActived)
        setIsLoading(true);
        handleUpdateMCPServerByAction(
            Constant.MCP_SERVER_UPDATE_ACTION_TYPE.TOGGLE_ACTIVE_IN_ORG,
            mcpData,
            {
                corporationInuse: corporationDetail.id,
                projectInuse: projectInuseDetail.id,
                userId: userDetail.id,
                panelType
            }
        )
            .then(response => handleUpdateSuccess(response, mcpServerData, projectActived))
            .catch(err => {
                console.log('callActiveInProject err: ', err);
            })
            .finally(() => {
                setIsLoading(false);
            });
    };

    const handleUpdateSuccess = (response, mcpServerData, projectActived) => {
        if (!Utils.isEmptyString(response?.error)) {
            if (response?.error === 'COMMSG030') {
                setIsShowPopUpReload(true);
            }
        }
        setListSettingApiProject(prev =>
            prev.map(item =>
                item.id === mcpServerData?.id
                    ? { ...item, projectActived }
                    : item
            )
        );
    };

    useEffect(() => {
        if (props.tabId === closeTabIdState) {
            let currentPanelInfo = Utils.getPanelInfo(props.panelId, panelList);
            if (!currentPanelInfo || Utils.isEmptyObject(currentPanelInfo)) return;
            closePanelTab({
                event: null,
                panelType: currentPanelInfo.type,
                panelId: props.panelId,
                tabId: props.tabId
            });
            setCloseTabIdState(0);
        }
    }, [closeTabIdState]);

    return (
        <div style={{ height: '100%' }}>
            <div className="mcp-server-header mcp-server-line-space">
                <div className="mcp-server-header-inner">
                    <h3 className="mcp-server-setting-list">
                        {I18n.get('MCP_SERVER_SETTING_LIST')}
                    </h3>
                </div>
            </div>
            <div className="mcp-server-body">
                <div className="mcp-server-body-line mcp-server-line-space">
                    <div className="">
                        <h4>{I18n.get('MCP_SERVER_SETTING_LABEL_PROJECT')}</h4>
                    </div>
                    <div className="mcp-server-last-title">
                        <h4>{I18n.get('MCP_SERVER_SETTING_ACTIVE_IN_PROJECT')}</h4>
                    </div>
                </div>
                
                <div className="mcp-server-list" ref={mcpServerListBody}>
                    {!Utils.isEmptyArray(listSettingApiProject) &&
                        listSettingApiProject.map(apiData => (
                            <div key={apiData.id} className="mcp-server-body-line mcp-server-line">
                                <button
                                    className="mcp-server-item btn-reset-default cursor-default"
                                >
                                    <OverFlowTooltipWithTabsMui value={Utils.serverNameWithPrefix(apiData.serverName, apiData.type)} />
                                </button>
                                {renderSettingMCPServer(isActiveProject(apiData), callActiveInProject, apiData)}
                            </div>
                        ))}
                </div>
            </div>
            <ConfirmDialog
                isOpen={isShowPopUpReload}
                msgConfirm={I18n.get('COMMSG030')}
                okCallBack={() => window.location.reload()}
            />
        </div>
    );
}

export default MCPServerListInProject;
